// import React, { useEffect, useRef, useState } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/effect-coverflow";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
// // import "./photoswipe.css";

// import "./Invitation.css";
// import $ from "jquery";
// import { useParams } from "react-router-dom";

// import { EffectCoverflow, Pagination, Navigation } from "swiper/modules";

// import image from "../assets/img/inviter_1.jpg";
// import image2 from "../assets/img/inviter_2.jpg";
// import image3 from "../assets/img/inviter_3.jpg";
// import PageHeading from "../common/PageHeading";
// import { useSwipeable } from "react-swipeable";
// import { BackArrowIcon } from "../../utils/SvgComponents";
// import PhotoSwipeLightbox from "photoswipe/lightbox";
// import "./styles.css";
// import Title from "../new-pages/Title";
// import { apiHandler } from "../../utils/apiHandler";
// import { EVENT_BASEURL } from "../../utils/Constants";

// const response = {
//     invitationImgs: [
//        image3,
//        image,
//        image2,

//     ],
//     title: "Katariya's Invitation",
//     titleBg: "1699125730882-@-home_invitation.jpg",
//     titleFg: "",
// };
// let responseWithImageHeightAndWith=[]
// //  response['invitationImgs'].forEach((image,i) => {


// //     const img = new Image();
// //     let hii={}
// //     img.src = image;
// //    hii.src=image
// //     img.onload = () => {
// //         hii.width = img.width;
// //         hii.height = img.height;


// //     };
// //     responseWithImageHeightAndWith[i]=hii

// //   });
// var timeOut;

// const Invitation = () => {
//     const { id } = useParams();
//     const [response , setResponse] = useState()
//     const [responseData, setResponseData] = useState(null);
//     const [openImageBox, setOpenImageBox] = useState(false);
//     const [activeSlide, setActiveSlide] = useState(0);

//     const [currentIndex, setCurrentIndex] = useState(0);
//     const [currentImageUrl, setCurrentImageUrl] = useState("");
//     const [loading, setLoading] = useState(true);
//     const [showImage, setShowImage] = useState(false);
//     const [hideImage, setHideImage] = useState(false);
//     const [lastIndex, setLastIndex] = useState(0);
//     const [hoverImage, setHoverImage] = useState({
//         backgroundImage: "",
//         backgroundPosition: "0% 0%",
//         backgroundSize: "125%",
//     });
//     const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
//     const [delayedSlideIndex, setDelayedSlideIndex] = useState(currentSlideIndex);
//     const [imageDataWithSize, setImageDataWithSize] = useState([]);
//     const lightboxRef = useRef(null);
//     const [viewportHeight, setViewportHeight] = useState(window.innerHeight);
//     const [backbtn, setBackbtn] = useState(false);

//     useEffect(() => {
//       const fetchDashBoard = async () => {
//           try {
//               const res = await apiHandler.post("/guest/fetch-feature", {
//                 _id: id,
//                 category : "Invitation"
//               });
//               console.log(res);
//               if (res) {
//                 setResponse(res);
//                 console.log(res.invitationImgs)
//                 setResponseData(res.invitationImgs);
//               }
//             } catch (err) {
//               console.error("Guest login error:", err);
//             }
//           };

//       fetchDashBoard();
//     },[])

//     useEffect(()=>{
//       const handleBackButton = () => {
//         if (window.history.state && window.history.state.back) {
//           setBackbtn(true); // Calling 'call' function when back button is clicked
//         }
//       };

//       window.addEventListener('popstate', handleBackButton);

//       return () => {
//         window.removeEventListener('popstate', handleBackButton);
//       };
//     })


// 	useEffect(() => {
// 	  const handleResize = () => {
// 		setViewportHeight(window.innerHeight);
// 	  };

// 	  window.addEventListener('resize', handleResize);
// 	  return () => {
// 		window.removeEventListener('resize', handleResize);
// 	  };
// 	}, []);
//     let isPopState = false;
//     const [loadPhoto , setLoadPhoto] = useState(false);
//     useEffect(() => {
//         setLoadPhoto(true);

//     },[openImageBox, currentSlideIndex, loadPhoto]);

//       const galleryRef = useRef(null);
//       const [galleryScrollTop, setGalleryScrollTop] = useState(0);

//     useEffect(() => {
//       window.$('[data-fancybox="gallery"]').fancybox({
//         buttons: ["slideShow", "thumbs", "zoom", "fullScreen", "share", "close"],
//         loop: false,
//         autoSize: true,
//         protect: true,
//         fitToView: true,
//         animationEffect: "zoom",
//         animationDuration: 400,

//         beforeShow: function () {
//           document.body.style.overflow = "hidden";
//         },

//         afterClose: function () {
//           document.body.style.overflow = "";
//           const gallery = galleryRef.current;
//           if (gallery) {
//             requestAnimationFrame(() => {
//               gallery.scrollTop = galleryScrollTop;
//             });
//           }

//         },

//         afterShow: function (instance) {
//           const swiper = document.querySelector('.swiper-mobile').swiper;
//           if (swiper && instance) {
//             const currentIndex = instance.currIndex; // Fancybox's current slide index
//             swiper.slideTo(currentIndex); // Sync Swiper with Fancybox
//             console.log("Gallery slide changed, Swiper updated to index:", currentIndex);
//           }
//         },

//         onInit: function (instance) {
//           console.log("Fancybox initialized");
//           instance.$refs.stage.on("click", "a[data-fancybox]", function () {
//             console.log("Image clicked");

//             const thumbnail = $(this).find("img")[0];
//             if (thumbnail) {
//               const rect = thumbnail.getBoundingClientRect();

//               const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
//               const visiblePortion = visibleHeight / rect.height;

//               console.log("Visible portion:", visiblePortion);

//               if (visiblePortion > 0.05) {
//                 console.log("okay");
//                 instance.current.opts.$thumbPosition = {
//                   left: rect.left,
//                   top: rect.top,
//                   width: rect.width,
//                   height: rect.height,
//                 };
//               } else {
//                 console.log("no okay");
//                 instance.current.opts.$thumbPosition = null;
//               }
//             }
//           });
//         }


//       });
//     })


// // useEffect(() => {
// //   if (response &&  response?.invitationImgs?.length) {
// //     const updated = response.invitationImgs.map((imgSrc, index) => {
// //       const item = { src: imgSrc, index };

// //       const img = new Image();
// //       img.src = imgSrc;

// //       img.onload = () => {
// //         item.width = img.width;
// //         item.height = img.height;

// //         setImageDataWithSize((prev) => {
// //           const copy = [...prev];
// //           copy[index] = item;
// //           return copy;
// //         });
// //       };

// //       return item;
// //     });

// //     // Set initial items (without width/height)
// //     setImageDataWithSize(updated);
// //   }
// // }, [response, responseData]);



//     useEffect(() => {
//         if(response){
//            const data = [...response.invitationImgs];
//           const _res = data.map((item, index) => {
//               return {
//                   index: index,
//                   url: item,
//               };
//           });
//           setCurrentImageUrl(data[0]);
//           setLoading(false);
//         }
//     }, [response, ]);

//     useEffect(() => {
//         setHoverImage((prev) => ({
//             ...prev,
//             backgroundImage:`url(${currentImageUrl})`,
//         }));
//     }, [currentImageUrl, ]);

//     useEffect(() => {
//       if(responseData){
//          const _res = responseData.find((item) => item.index === currentIndex);
//         if (_res) {
//             // setCurrentImageUrl(_res?.url);
//         }
//       }   

//     }, [currentIndex, responseData]);


//     const handlers = useSwipeable({
//         delta: 10,
//         onSwipedRight: () => {
//           if (!responseData || currentIndex === 0) return;

//           const prev = responseData.find((item) => item.index === currentIndex - 1);
//           if (prev) {
//             setCurrentImageUrl(prev.url);
//             setCurrentIndex(currentIndex - 1);
//           }
//         },
//         onSwipedLeft: () => {
//           if (!responseData || currentIndex === responseData.length - 1) return;

//           const next = responseData.find((item) => item.index === currentIndex + 1);
//           if (next) {
//             setCurrentImageUrl(next.url);
//             setCurrentIndex(currentIndex + 1);
//           }
//         },
//       });

//     const handleImageClick = (index) => {
//         if (index === currentIndex) {
//             setShowImage(true);
//             setHideImage(true);
//             setLastIndex(currentIndex);
//         }
//     };

//     const handleMouseMove = (e) => {
//         const { left, top, width, height } = e.target.getBoundingClientRect();
//         const x = ((e.pageX - left) / width) * 100;
//         const y = ((e.pageY - top) / height) * 100;
//         setHoverImage((prev) => ({
//             ...prev,
//             backgroundPosition: `${x}% ${y}%`,
//         }));
//     };





// useEffect(() => {
//   const timeout = setTimeout(() => {
//     setDelayedSlideIndex(currentSlideIndex);
//   }, 300); // Delay matches slide animation

//   return () => clearTimeout(timeout);
// }, [currentSlideIndex, activeSlide]);


//     return (
//         <div style={{zIndex:'333333',backgroundColor:'white'}}>
//             <div className="hidden md:block">
//                 <div className="grid grid-cols-12 ">
//                     <div className="col-span-5">
//                         <div
//                             id="hoverDiv"
//                             className="w-full h-full flex justify-center items-center bg-black"
//                             onMouseMove={handleMouseMove}
//                             style={{ ...hoverImage }}
//                         >
//                             <img
//                                 src={EVENT_BASEURLcurrentImageUrl}
//                                 alt=""
//                             />
//                         </div>
//                     </div>
//                     <div className="col-span-7 mx-auto w-full h-screen">

//                     <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center",
//            }}>
//           <div
//             className="    p-0 mb-0  "
//           >
//             <Title title={"Our Invitation"} textColor={"text-black"} style={{ fontSize: "2.5rem" }} pl={'pl-6'}/>

//           </div>
//         </div>                        {loading ? (
//                             <></>
//                         ) : (
//                             <Swiper
//                                 effect={"coverflow"}
//                                 grabCursor={true}
//                                 slideToClickedSlide={true}
//                                 // loop={true}
//                                 // height="100%"
//                                 onRealIndexChange={(e) =>{
//                                   setCurrentIndex(e.realIndex)
//                                   setCurrentImageUrl( responseData && responseData[e.realIndex])
//                                 }

//                                 }
//                                 centeredSlides={true}
//                                 slidesPerView={3}
//                                 // slidesPerGroupAuto={true}
//                                 loopAddBlankSlides={true}
//                                 freeMode={true}
//                                 updateOnWindowResize={true}
//                                 autoHeight={true}
//                                 keyboard={true}
//                                 coverflowEffect={{
//                                     rotate: 0,
//                                     stretch: 80,
//                                     depth: 150,
//                                     modifier: 1,
//                                     slideShadows: false,
//                                 }}
//                                 onUpdate={responseData && responseData}
//                                 // navigation={{
//                                 //     enabled: true,
//                                 // }}
//                                 // pagination={{
//                                 //     type: "bullets",
//                                 // }}
//                                 modules={[
//                                     EffectCoverflow,
//                                     Pagination,
//                                     Navigation,
//                                 ]}
//                                 className="mySwiper"
//                                  initialSlide={0}
//                                 speed={500}
//                                 spaceBetween={-50}
//                             >
//                                 {responseData && responseData.map((item) => (
//                                     <SwiperSlide>
//                                         <div>
//                                             <img
//                                                 src={item}
//                                                 alt=""
//                                                 className="bg-cover-shadow w-[300px]"
//                                             />
//                                         </div>
//                                     </SwiperSlide>
//                                 ))}
//                             </Swiper>
//                         )}
//                     </div>
//                 </div>
//             </div>

//       <div className="  block md:hidden relative h-[100vh]" id="my-gallery" >
// <div style={{height:viewportHeight}}>
// <Swiper
//   effect={"coverflow"}
//   initialSlide={currentSlideIndex}
//   grabCursor={true}
//   slideToClickedSlide={true}
//   // loop={true}
//   centeredSlides={true}
//   slidesPerView={1.5}
//   autoHeight={true}
//   keyboard={true}
//   onSlideChange={(swiper) => {
//     setCurrentSlideIndex(swiper.activeIndex);
//   }
//   }                    
//   coverflowEffect={{
//     rotate: 0,
//     stretch: 50,
//     depth: 100,
//     modifier: 1,
//     slideShadows: false,
// }}
//   modules={[EffectCoverflow, Pagination, Navigation]}
//   className="mySwiper swiper-mobile"
//   // speed={500}
//   //   spaceBetween={-250}
// >
//   {responseData && responseWithImageHeightAndWith?.map((image, i) =>{
//     (delayedSlideIndex === i) && (setTimeout(() => {
//     setTimeout(() => {
//       setActiveSlide(i);
//     }, 100);}));
//     return (
//         <SwiperSlide key={i} >
//           {
//             delayedSlideIndex === i ?(
//               <a
//                 href={image.src}
//                 rel="noreferrer"
//                 data-fancybox="gallery"
//                 data-pswp-width={image.width}
//                 data-pswp-height={image.height}
//                 style={{
//                   position: "relative",
//                   zIndex: 1000,
//                   pointerEvents: 'auto'
//                 }}
//                 target="_blank"
//                 className={'item-d active'}
//                 onClick={()=>{
//                   console.log("Touch started");
//                     setActiveSlide(i);
//                     setTimeout(() => {
//                       setOpenImageBox(true); // Open the lightbox without waiting for state lag
//                       console.log("Opening lightbox with slide:", i);
//                     }, 0);

//                 }}

//           >
//             <img src={image.src} height={image.height} width={image.width}   alt="" className="bg-cover-shadow" />
//           </a>
//             ): (
//               <a
//                 href={image.src}
//                 rel="noreferrer"
//                 data-fancybox="gallery"
//                 data-pswp-width={image.width}
//                 data-pswp-height={image.height}
//                 target="_blank"
//                 className={activeSlide === i ? 'item-d ' : 'item-d'}
//                 onClick={(e)=>{
//                   e.preventDefault();
//                 }}
//             >
//             <img src={image.src} height={image.height} width={image.width}   alt="" className="bg-cover-shadow" />
//           </a>
//             )
//           }
//         </SwiperSlide>
//       )
//   })}
// </Swiper>
// </div>

// </div>


//         </div>
//     );
// };

// export default Invitation;




import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import "swiper/css/pagination";
// import "./photoswipe.css";

import "./Invitation.css";
import $ from "jquery";

import { EffectCoverflow, Pagination, Navigation } from "swiper/modules";

import PageHeading from "../common/PageHeading";
import { useSwipeable } from "react-swipeable";
import { BackArrowIcon } from "../../utils/SvgComponents";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import "./styles.css";
import Title from "../new-pages/Title";
import { useParams } from "react-router-dom";
import { apiHandler } from "../../utils/apiHandler";
import { EVENT_BASEURL } from "../../utils/Constants";

const response = {};
var timeOut;

const Invitation = () => {
  const { id } = useParams();
  const [response, setResponse] = useState();
  const [responseData, setResponseData] = useState(null);
  const [openImageBox, setOpenImageBox] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentImageUrl, setCurrentImageUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [showImage, setShowImage] = useState(false);
  const [hideImage, setHideImage] = useState(false);
  const [lastIndex, setLastIndex] = useState(0);
  const [hoverImage, setHoverImage] = useState({
    backgroundImage: "",
    backgroundPosition: "0% 0%",
    backgroundSize: "125%",
  });
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [delayedSlideIndex, setDelayedSlideIndex] = useState(currentSlideIndex);

  const lightboxRef = useRef(null);
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);
  const [backbtn, setBackbtn] = useState(false);
  let NewUsername = "";

  const pathArray = window.location.pathname.split("/").filter(Boolean);

  if (pathArray.includes("Login")) {
    // Handle special case when URL contains "Login"
    NewUsername = pathArray[1];
  } else {
    NewUsername = pathArray[0]
  }

  let data = JSON.parse(localStorage.getItem(`logindata_${NewUsername}`))
  const newImgUrl = `https://welcometowedding.com/events/${data?._id}/`
  console.log(newImgUrl);
  useEffect(() => {
    const fetchDashBoard = async () => {
      try {
        const res = await apiHandler.post("/guest/fetch-feature", {
          _id: id,
          category: "Invitation"
        });
        if (res) {
          setResponse(res);
          console.log(res.invitationImgs)
          setResponseData(res.invitationImgs);
        }
      } catch (err) {
        console.error("Guest login error:", err);
      }
    };

    fetchDashBoard();
  }, [])


  useEffect(() => {
    const handleBackButton = () => {
      if (window.history.state && window.history.state.back) {
        setBackbtn(true); // Calling 'call' function when back button is clicked
      }
    };

    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  })


  useEffect(() => {
    const handleResize = () => {
      setViewportHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  let isPopState = false;
  // let chid_Name = ".item-d";
  // let lightboxInstance =  new PhotoSwipeLightbox({
  //   gallery: "#my-gallery",
  //   children: chid_Name,
  //   pswpModule: () => import("photoswipe"),
  // });
  const [loadPhoto, setLoadPhoto] = useState(false);
  useEffect(() => {
    // if(loadPhoto){
    setLoadPhoto(true);

    // }else{
    //   setLoadPhoto(true);
    //   lightboxInstance = new PhotoSwipeLightbox({
    //     gallery: "#my-gallery",
    //     children: ".item-d",
    //     pswpModule: () => import("photoswipe"),
    //   });
    // }

  }, [openImageBox, currentSlideIndex, loadPhoto]);

  const galleryRef = useRef(null);
  const [galleryScrollTop, setGalleryScrollTop] = useState(0);

  useEffect(() => {
    window.$('[data-fancybox="gallery"]').fancybox({
      buttons: ["slideShow", "thumbs", "zoom", "fullScreen", "share", "close"],
      loop: false,
      autoSize: true,
      protect: true,
      fitToView: true,
      animationEffect: "zoom",
      animationDuration: 400,

      beforeShow: function () {
        document.body.style.overflow = "hidden";
      },

      afterClose: function () {
        document.body.style.overflow = "";
        const gallery = galleryRef.current;
        if (gallery) {
          requestAnimationFrame(() => {
            gallery.scrollTop = galleryScrollTop;
          });
        }

        // const swiper = document.querySelector('.swiper-mobile').swiper;
        // if (swiper) {
        //   swiper.slideTo(currentSlideIndex); // This forces Swiper to move to the first slide
        // }
        // console.log(swiper.activeIndex);
      },

      afterShow: function (instance) {
        const swiper = document.querySelector('.swiper-mobile').swiper;
        if (swiper && instance) {
          const currentIndex = instance.currIndex; // Fancybox's current slide index
          swiper.slideTo(currentIndex); // Sync Swiper with Fancybox
          console.log("Gallery slide changed, Swiper updated to index:", currentIndex);
        }
      },

      onInit: function (instance) {
        console.log("Fancybox initialized");
        instance.$refs.stage.on("click", "a[data-fancybox]", function () {
          console.log("Image clicked");

          const thumbnail = $(this).find("img")[0];
          if (thumbnail) {
            const rect = thumbnail.getBoundingClientRect();

            const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
            const visiblePortion = visibleHeight / rect.height;

            console.log("Visible portion:", visiblePortion);

            if (visiblePortion > 0.05) {
              console.log("okay");
              instance.current.opts.$thumbPosition = {
                left: rect.left,
                top: rect.top,
                width: rect.width,
                height: rect.height,
              };
            } else {
              console.log("no okay");
              instance.current.opts.$thumbPosition = null;
            }
          }
        });
      }


    });
  })





  useEffect(() => {
    if (response) {
      const data = [...response.invitationImgs];
      const _res = data.map((item, index) => {
        return {
          index: index,
          url: item,
        };
      });
      setCurrentImageUrl(data[0]);
      setLoading(false);
    }
  }, [response]);

  useEffect(() => {
    if (currentImageUrl) {
      setHoverImage((prev) => ({
        ...prev,
        backgroundImage: `url(${newImgUrl + currentImageUrl})`,
      }));
    }
  }, [currentImageUrl]);

  useEffect(() => {
    if (response) {
      const _res = responseData.find((item) => item.index === currentIndex);
      if (_res) {
        // setCurrentImageUrl(_res?.url);
      }
    }
  }, [currentIndex], response);

  const handlers = useSwipeable({
    delta: 10,
    onSwipedRight: () => {
      if (!responseData || currentIndex === 0) return;

      const prev = responseData.find((item) => item.index === currentIndex - 1);
      if (prev) {
        setCurrentImageUrl(prev.url);
        setCurrentIndex(currentIndex - 1);
      }
    },
    onSwipedLeft: () => {
      if (!responseData || currentIndex === responseData.length - 1) return;

      const next = responseData.find((item) => item.index === currentIndex + 1);
      if (next) {
        setCurrentImageUrl(next.url);
        setCurrentIndex(currentIndex + 1);
      }
    },
  });


  const handleImageClick = (index) => {
    if (index === currentIndex) {
      setShowImage(true);
      setHideImage(true);
      setLastIndex(currentIndex);
    }
  };

  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = ((e.pageX - left) / width) * 100;
    const y = ((e.pageY - top) / height) * 100;
    setHoverImage((prev) => ({
      ...prev,
      backgroundPosition: `${x}% ${y}% `,
    }));
  };



  useEffect(() => {
    const timeout = setTimeout(() => {
      setDelayedSlideIndex(currentSlideIndex);
    }, 300); // Delay matches slide animation

    return () => clearTimeout(timeout);
  }, [currentSlideIndex, activeSlide]);

  console.log(EVENT_BASEURL + currentImageUrl)
  console.log(`https://welcometowedding.com/events/${id}/${currentImageUrl}`)

  return (
    <div style={{ zIndex: '333333', backgroundColor: 'white' }}>
      <div className="hidden md:block">
        <div className="grid grid-cols-12 ">
          <div className="col-span-5">
            <div
              id="hoverDiv"
              className="w-full h-full flex justify-center items-center bg-black animation-fadeIn"
              onMouseMove={handleMouseMove}
              style={{ ...hoverImage }}
            >
              {currentImageUrl && <img
                onLoad={() => setIsLoading(false)}
                className={`bg-cover-shadow  animate-fadeIn  object-cover transition-all duration-500 ${isLoading ? "blur-lg scale-105" : "blur-0 scale-100"
                  }`}

                src={newImgUrl + currentImageUrl}
                alt=""
              />}
            </div>
          </div>
          <div className="col-span-7 mx-auto w-full h-screen">

            <div style={{
              display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center",
            }}>
              <div
                className="    p-0 mb-0  "
              >
                <Title title={"Our Invitation"} textColor={"text-black"} style={{ fontSize: "2.5rem" }} pl={'pl-6'} />

              </div>
            </div>                        {loading ? (
              <></>
            ) : (
              <Swiper
                effect={"coverflow"}
                grabCursor={true}
                slideToClickedSlide={true}
                // loop={true}
                // height="100%"
                onRealIndexChange={(e) => {
                  setCurrentIndex(e.realIndex)
                  setCurrentImageUrl(responseData[e.realIndex])
                }

                }
                centeredSlides={true}
                slidesPerView={3}
                // slidesPerGroupAuto={true}
                loopAddBlankSlides={true}
                freeMode={true}
                updateOnWindowResize={true}
                autoHeight={true}
                keyboard={true}
                coverflowEffect={{
                  rotate: 0,
                  stretch: 80,
                  depth: 150,
                  modifier: 1,
                  slideShadows: false,
                }}
                onUpdate={responseData}
                // navigation={{
                //     enabled: true,
                // }}
                // pagination={{
                //     type: "bullets",
                // }}
                modules={[
                  EffectCoverflow,
                  Pagination,
                  Navigation,
                ]}
                className="mySwiper"
                initialSlide={0}
                speed={500}
                spaceBetween={-50}
              >
                {responseData.map((item) => (
                  <SwiperSlide>
                    <div>
                      <img
                        src={newImgUrl + item}
                        alt=""
                        onLoad={() => setIsLoading(false)}
                        className={`bg-cover-shadow w-[300px] animate-fadeIn  object-cover transition-all duration-500 ${isLoading ? "blur-lg scale-105" : "blur-0 scale-100"
                          }`}
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>
        </div>
      </div>

      <div className="  block md:hidden relative h-[100vh]" id="my-gallery" >
        <div style={{ height: viewportHeight }}>
          <Swiper
            effect={"coverflow"}
            grabCursor={true}
            slideToClickedSlide={true}
            // loop={true}
            centeredSlides={true}
            slidesPerView={1.5}
            autoHeight={true}
            keyboard={true}
            onSlideChange={(swiper) => {
              setCurrentSlideIndex(swiper.activeIndex);
            }
            }
            coverflowEffect={{
              rotate: 0,
              stretch: 50,
              depth: 100,
              modifier: 1,
              slideShadows: false,
            }}
            modules={[EffectCoverflow, Pagination, Navigation]}
            className="mySwiper swiper-mobile"
          // speed={500}
          //   spaceBetween={-250}
          >
            {responseData?.map((image, i) => {
              (delayedSlideIndex === i) && (setTimeout(() => {
                setTimeout(() => {
                  setActiveSlide(i);
                }, 100);
              }));
              return (
                <SwiperSlide key={i} >
                  {
                    delayedSlideIndex === i ? (
                      <a
                        href={newImgUrl + image}
                        rel="noreferrer"
                        data-fancybox="gallery"
                        data-pswp-width={image.width}
                        data-pswp-height={image.height}
                        style={{
                          position: "relative",
                          zIndex: 1000,
                          pointerEvents: 'auto'
                        }}
                        target="_blank"
                        className={'item-d active'}
                        onClick={() => {
                          console.log("Touch started");
                          setActiveSlide(i);
                          setTimeout(() => {
                            setOpenImageBox(true); // Open the lightbox without waiting for state lag
                            console.log("Opening lightbox with slide:", i);
                          }, 0);

                        }}

                      >
                        <img
                          onLoad={() => setIsLoading(false)}
                          className={`bg-cover-shadow   object-cover transition-all duration-500 ${isLoading ? "blur-lg scale-105" : "blur-0 scale-100"
                            }`}
                          src={newImgUrl + image} height={image.height} width={image.width} alt="" />
                      </a>
                    ) : (
                      <a
                        href={newImgUrl + image}
                        rel="noreferrer"
                        data-fancybox="gallery"
                        data-pswp-width={image.width}
                        data-pswp-height={image.height}
                        target="_blank"
                        className={activeSlide === i ? 'item-d ' : 'item-d'}
                        onClick={(e) => {
                          e.preventDefault();
                        }}
                      >
                        <img src={newImgUrl + image} height={image.height} width={image.width} alt="" className="bg-cover-shadow" />
                      </a>
                    )
                  }
                </SwiperSlide>
              )
            })}
          </Swiper>
        </div>

      </div>


    </div>
  );
};

export default Invitation;
